<script setup>
import { useI18n } from 'vue-i18n'
const { setLocale } = useI18n()
const application = applicationStore()
const { locale } = storeToRefs(application)


function changeLocale(locale) {
   setLocale(locale)
   application.setLocale(locale)
}

</script>

<template>
   <div class="cursor-pointer mt-1">
      <div class="flex ml-2">
          <span class="inline-block font-mono text-16 items-center justify-center uppercase border-black hover:opacity-100 cursor-pointer text-ffc"  @click="changeLocale('it')" :class=" locale == 'it' ? 'font-bold':'font-light'">it</span>
          <span>&nbsp;/&nbsp;</span>
          <span class="inline-block font-mono text-16 items-center justify-center uppercase border-black hover:opacity-100 cursor-pointer text-ffc"  @click="changeLocale('en')" :class=" locale == 'en' ? 'font-bold':'font-light'">en</span>   
     </div>
   </div>
</template>